import * as React from "react";
import AuthService from '../../services/authService';
import UserService from "../../services/userService";
import { NotificationSchedulerModel } from '../../models/notificationSchedulerModel';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import Spinner from '../../common/components/spinner/spinner';
import Growl from '../../common/components/alertMessage/growl';
import Translate from "../../common/functions/translate";
import logo01white from "../../assets/images/logos/Logo-01-icon.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AcceptanceDialog from '../user/userNotification/userNotificationAcceptanceDialog';
import { faCalendarCheck, faCalendar, faChevronRight, faClock } from '@fortawesome/free-solid-svg-icons';

interface IProps {
    lang: string;
    errorShow: any;
    updateCount: any;
    listElm: any;
    history: any;
    closeDrawer: any;
}

interface IState {
    notifications: Array<NotificationSchedulerModel>,
    isLoading: boolean,
    acceptanceShow: boolean,
    selectedId: number
}

class NotificationComponent extends React.Component<IProps, IState> {
    userService = new UserService();
    authService = new AuthService();
    growl: any;
    intervalId: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            notifications: new Array<NotificationSchedulerModel>(),
            isLoading: false,
            acceptanceShow: false,
            selectedId: 0
        }
    }

    componentDidMount() {
        this.getNotifications(true);
    }

    getNotifications = (isInit: boolean) => {
        this.setState({
            isLoading: true
        });

        if (this.authService.isAuthenticated()) {
            this.userService.getNotSeenNotifications(this.props.lang).then(
                (data: any) => {
                    if (data) {
                        if (isInit) {
                            this.setState({
                                isLoading: false,
                                notifications: [...data]
                            });
                        }
                        this.props.updateCount();
                    }
                })
                .catch(error => {
                    this.setState({
                        isLoading: false
                    });
                    this.props.errorShow(error);
                });
        }
    }

    onAllNotificationsClick = (event) => {
        event.preventDefault();
        this.props.history.push('/user/notifications');
        this.props.closeDrawer();
    }

    openDialog = (m: NotificationSchedulerModel, event) => {
        event.preventDefault();
        this.setState({ selectedId: m.notificationSchedulerId, acceptanceShow: true });
    }

    closeDialog = () => {
        this.setState({ acceptanceShow: false }, () => this.getNotifications(true));
        this.props.updateCount();
    }

    markAllAsSeen = (event) => {
        event.preventDefault();
        if (!this.state.notifications || this.state.notifications.length < 1) {
            return;
        }
        this.setState({
            isLoading: true
        });
        if (this.authService.isAuthenticated()) {
            this.userService.markAllAsSeen().then(
                (data: any) => {
                    if (data) {
                        this.setState({
                            isLoading: false
                        }, () => this.getNotifications(true));
                        this.props.updateCount();
                    }
                })
                .catch(error => {
                    this.setState({
                        isLoading: false
                    });
                    this.props.errorShow(error);
                });
        }
    }

    returnNotificationList = (notifications: NotificationSchedulerModel[], stringForEmptyMessage: string) => {
        return <ul className="list-items">
            {notifications && notifications.length > 0 ? notifications.map((m: NotificationSchedulerModel) =>
                <li key={m.notificationSchedulerId + 'Scheduler'} onClick={(e) => this.openDialog(m, e)}>
                    <div className="item-action">
                        <img src={logo01white} className="app-logo" alt="logo" style={{ marginRight: 15 }} />
                    </div>
                    <div className="item-info" style={{ width: 'calc(100% - 120px)' }}>
                        <div className="item-name">
                            {m.userId == this.authService.getUserId() ? Translate("You have to take medicines at") :
                                m.userName + ' ' + Translate("have to take his/hers medicines at")}
                            {" " + HelperFunctions.fomatTimeAsStringWithoutSeconds(new Date(m.nextExecutionDate))
                                + " " + Translate("oclock on date") + " " + HelperFunctions.fomatDatesStringWithLang(new Date(m.nextExecutionDate), this.props.lang)}
                        </div>
                        <div className="item-desc">
                            {m.medicineName ? m.medicineName : null}
                        </div>
                        {m.isSnoozed === true ?
                            <div className="item-desc">
                                <FontAwesomeIcon icon={faClock} />
                                <span> {Translate('snoozed for') + " " + HelperFunctions.fomatDateTimeAsStringWithLang(new Date(m.executedAt), this.props.lang)}</span>
                            </div>
                            :
                            <div className="item-desc" style={{ color: 'red' }}>
                                {m.takenAt ? null : Translate('No Intake')}
                            </div>
                        }
                    </div>
                </li>
            ) : <div style={{ padding: 10 }}>{Translate(stringForEmptyMessage)}</div>}
        </ul>
    }

    render() {
        const { notifications, isLoading, acceptanceShow, selectedId } = this.state;
        let newNotifications = notifications.filter(r => r.seenAt == null);
        let oldNotifications = notifications.filter(r => r.seenAt != null);

        return (
            <>
                <Growl ref={(el) => this.growl = el} />
                <div style={{ width: '100%', height: '40px' }}>
                    <h3 style={{ float: 'left' }}>{Translate('Notifications')}</h3>
                    {/* <div style={{ float: "right", marginTop: 12, fontSize: '12px' }}><a href="" onClick={(e) => this.markAllAsSeen(e)}>{Translate("Mark all as seen")}</a></div> */}
                </div>
                <div id="map-info-scrollbar" style={{ overflow: 'scroll', maxHeight: 230, overflowX: 'hidden', paddingRight: 10 }}>
                    <div>
                        <div className="notifications-panel-title">{Translate("New") + " (" + newNotifications.length + ")"}</div>
                        {this.returnNotificationList(newNotifications, 'You don\'t have new notifications')}
                    </div>
                    <div>
                        <div className="notifications-panel-title">{Translate("Old") + " (" + oldNotifications.length + ")"}</div>
                        {this.returnNotificationList(oldNotifications, 'You don\'t have old notifications')}
                    </div>
                </div>
                <div style={{ textAlign: 'center', paddingTop: 15 }}>
                    <a href='' onClick={(e) => this.onAllNotificationsClick(e)}>{Translate('See All')}</a>
                </div>
                {isLoading ? <Spinner inlineSpinner={true} /> : null}

                {acceptanceShow ?
                    <AcceptanceDialog
                        isVisible={acceptanceShow}
                        handleCancelButton={this.closeDialog}
                        handleSaveButton={this.closeDialog}
                        notifiicationSchedulerId={selectedId}></AcceptanceDialog>
                    : null}
            </>
        )
    }
}

export default NotificationComponent;